import React from 'react';
import { connect } from 'react-redux';
import ToggleCell from '@/components/table/ToggleCell';
import { states } from '@/constants/lifecycle';
import { showArchiveUser } from '../actions';

const UserArchiveCell = ({
  category,
  user,
  showArchive,
  disabled,
}) => (
  <ToggleCell
    className="aridhia-user-archive-cell"
    checked={user.archived}
    disabled={disabled}
    id={`aridhia-user-archive-cell-${user.uuid}`}
    label={user.name}
    onClick={() => showArchive(category, user.code)}
  />
);

const mapStateToProps = ({
  auth: { role: { permissions: { users: { destroy } } } },
}, { user }) => ({
  disabled: user.updateStatus === states.PENDING || !destroy,
});

const mapDispatchToProps = {
  showArchive: showArchiveUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserArchiveCell);
